<template>
  <div>
    <b-modal :active.sync="isSelectionModalActive" :width="640">
      <div class="card">
        <div class="card-content">
          <div class="content">
            <p v-for="item in formatedSelection" :key="item.id">
              {{ $t(item.id) }} -
              <a @click="removeFromSelection(item.id)">eliminar</a>
            </p>
          </div>
        </div>
      </div>
    </b-modal>

    <b-field :label="$t(label)">
      <b-select
        @input="changeSelection"
        v-model="selectedFilter"
        :placeholder="$t('Selecciona')"
      >
        <option key="all" value="all">{{ $t('Worldwide') }}</option>
        <option key="regions" value="regions">{{ $t('Regiones') }}</option>
        <option key="selected" value="selected">{{
          $t('Solo seleccionadas')
        }}</option>
        <option key="all_except_selected" value="all_except_selected">{{
          $t('Todos excepto seleccionados')
        }}</option>
        <option key="all_except_excluded" value="all_except_excluded">{{
          $t('Todos excepto excluídos')
        }}</option>
      </b-select>
      <p class="control">
        <button
          @click="isSelectionModalActive = true"
          class="button is-primary"
        >
          {{ $t('Selección') }} ({{ selection.length }})
        </button>
      </p>
      <transition name="inputShow">
        <customized-tag-input
          v-if="isTagInputVisible"
          :options="options"
          v-model="selectedTags"
          @input="changeSelection"
        />
        <advanced-checkbox-group
          v-if="selectedFilter == 'regions'"
          @input="changeRegionSelection"
          v-model="selectedRegions"
          :options="regions"
        >
        </advanced-checkbox-group>
      </transition>
    </b-field>
  </div>
</template>

<script>
import CustomizedTagInput from '@/components/common/CustomizedTagInput.vue'
import AdvancedCheckboxGroup from '@/components/common/AdvancedCheckboxGroup.vue'
export default {
  components: { CustomizedTagInput, AdvancedCheckboxGroup },
  props: {
    options: Array,
    value: Array,
    label: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    selectedFilter: 'selected',
    filteredTags: [],
    isSelectionModalActive: false,
    selection: [],
    selectedTags: [],
    formatedSelection: [],
    selectedRegions: [],
    regions: [
      {
        id: 'AS',
        title: 'Asia'
      },
      {
        id: 'APAC',
        title: 'Asia-Pacífico'
      },
      {
        id: 'ME',
        title: 'Oriente medio'
      },
      {
        id: 'EU',
        title: 'Europa'
      },
      {
        id: 'AF',
        title: 'África'
      },
      {
        id: 'NAF',
        title: 'Norte de Africa'
      },
      {
        id: 'NRD',
        title: 'Países nórdicos'
      },
      {
        id: 'EUW',
        title: 'Europa Occidental'
      },
      {
        id: 'EUE',
        title: 'Europa Oriental'
      },
      {
        id: 'EUS',
        title: 'Europa del Sur'
      },
      {
        id: 'NA',
        title: 'Norte América'
      },
      {
        id: 'SA',
        title: 'Sudamérica'
      },
      {
        id: 'CBN',
        title: 'Caribe'
      },
      {
        id: 'OC',
        title: 'Oceanía'
      },
      {
        id: 'OECD',
        title: 'OECD'
      }
    ]
  }),
  watch: {
    value: function(val) {
      let self = this
      this.selection = val
      self.formatedSelection = []
      self.options.forEach(function(element) {
        if (val.includes(element.id)) {
          self.formatedSelection.push(element)
        }
      })
    }
  },
  mounted() {},
  computed: {
    isTagInputVisible: function() {
      const visibleOptions = ['selected', 'all_except_selected']
      return visibleOptions.includes(this.selectedFilter)
    }
  },
  methods: {
    removeFromSelection(id) {
      const index = this.selection.indexOf(id)
      this.selection.splice(index, 1)
      this.formatedSelection.splice(index, 1)
    },
    changeRegionSelection() {
      let self = this
      self.selection = []
      self.formatedSelection = []
      self.options.forEach(function(element) {
        element.regions.forEach(function(region) {
          if (self.selectedRegions.includes(region)) {
            if (!self.selection.includes(element.id)) {
              self.selection.push(element.id)
              self.formatedSelection.push(element)
            }
          }
        })
      })
      self.$emit('input', self.selection)
    },
    changeSelection() {
      let self = this
      switch (self.selectedFilter) {
        case 'all':
          self.selection = []
          self.formatedSelection = []
          self.options.forEach(function(element) {
            self.selection.push(element.id)
            self.formatedSelection.push(element)
          })
          break
        case 'selected':
          self.selection = []
          self.formatedSelection = []
          self.options.forEach(function(element) {
            if (self.selectedTags.includes(element.id)) {
              self.selection.push(element.id)
              self.formatedSelection.push(element)
            }
          })
          break
        case 'all_except_excluded':
          self.selection = []
          self.formatedSelection = []
          self.options.forEach(function(element) {
            if (element.excluded == false) {
              self.selection.push(element.id)
              self.formatedSelection.push(element)
            }
          })
          break
        case 'regions':
          self.selection = []
          self.formatedSelection = []
          break
        case 'all_except_selected':
          self.selection = []
          self.formatedSelection = []
          self.options.forEach(function(element) {
            if (!self.selectedTags.includes(element.id)) {
              self.selection.push(element.id)
              self.formatedSelection.push(element)
            }
          })
          break
        default:
          self.selection = self.options
      }
      self.$emit('input', self.selection)
    }
  }
}
</script>
<style lang="scss">
#campos {
  &.section section {
    input,
    select,
    button,
    .icon.is-left {
      font-size: 16px !important;
    }
    > div {
      width: 100%;
      margin: 60px 0;
      padding: 0 30px;
    }
    .tag {
      width: 48%;
      font-size: 16px;
    }
    select[multiple='multiple'] {
      height: 6.8em !important;
    }
  }
}
.field {
  &.has-addons {
    flex-wrap: wrap;
  }
}

label.label {
  width: 100%;
}
.modal-content {
  &.card {
    min-height: 50vh;
  }
  &.content {
    max-height: 100%;
    top: none;
    padding: 10% 5%;
    width: 100%;
  }
}
</style>
